import React from 'react';

function createContext(_a) {
    var name = _a.name;
    var context = React.createContext(undefined);
    context.displayName = name;
    var hookName = "use".concat(name, "Context");
    var providerName = "".concat(name, "Provider");
    function useContext(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.optional, optional = _c === void 0 ? false : _c, fallbackContext = _b.fallbackContext;
        var c = React.useContext(context);
        if (!c) {
            if (optional || fallbackContext) {
                return (fallbackContext || {});
            }
            else {
                throw new Error("".concat(hookName, " must be used in a child of a ").concat(providerName));
            }
        }
        return c;
    }
    return [useContext, context];
}

export { createContext };
//# sourceMappingURL=createContext.js.map
